import { render, staticRenderFns } from "./PayU.vue?vue&type=template&id=4916e381"
import script from "./PayU.vue?vue&type=script&lang=js"
export * from "./PayU.vue?vue&type=script&lang=js"
import style0 from "./PayU.vue?vue&type=style&index=0&id=4916e381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports